import React from 'react';
import { useChatWidgetContext } from '@/widget/services/useChatWidgetContext';
import cx from 'classnames';
import WidgetIcon from './WidgetIcon';
import ExternalLinkIcon from './ExternalLinkIcon';
import styles from './ChannelPickers.module.scss';

function ChannelPickers() {
  const { settings } = useChatWidgetContext();
  const { channels, position } = settings;

  return (
    <div className={cx(styles.channelsContainer, styles[position])}>
      {channels.map((channel) => (
        <ExternalLinkIcon
          key={channel.type}
          link={channel.link}
          type={channel.type}
        />
      ))}
      <WidgetIcon />
    </div>
  );
}

export default ChannelPickers;
